(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/draws/assets/javascripts/lotto-draw.js') >= 0) return;  svs.modules.push('/components/numbergames/draws/assets/javascripts/lotto-draw.js');

'use strict';

const _svs$numbergames$prod = svs.numbergames.productMapping.CONSTANTS,
  LOTTO = _svs$numbergames$prod.LOTTO,
  LOTTO_WEDNESDAY = _svs$numbergames$prod.LOTTO_WEDNESDAY,
  LOTTO_SATURDAY = _svs$numbergames$prod.LOTTO_SATURDAY;

class LottoDraw extends svs.numbergames.draws.Draws {
  constructor() {
    super({
      productItsIds: [LOTTO_WEDNESDAY, LOTTO_SATURDAY]
    });
  }
  get product() {
    return LOTTO;
  }
}
svs.numbergames.draws.LottoDraw = LottoDraw;

 })(window);